'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'croissant';
var width = 512;
var height = 512;
var aliases = [129360];
var unicode = 'f7f6';
var svgPathData = 'M256 32c56.1 0 107.4 20.6 146.7 54.7l-104.7 104.7-56.8-159c4.9-.3 9.9-.5 14.8-.5zm169.3 77.3c20.6 23.7 36.2 51.8 45.4 82.7l-128.1 0 82.7-82.7zM310.6 224l200.1 0-3.9-19.2C483.2 88 379.9 0 256 0 114.6 0 0 114.6 0 256 0 379.9 88 483.2 204.8 506.9l19.2 3.9 0-200.1 2.1-2.1c18 7.7 29.2 12.5 33.6 14.4l7.7-7.7 48-48 7.2-7.2c-1.3-3.6-5.5-15.4-12.6-35.4l.8-.8zM194.4 295L86.7 402.7c-34.1-39.3-54.7-90.6-54.7-146.7 0-10.1 .7-20 2-29.8L194.4 295zM109.3 425.3l82.7-82.7 0 128.1c-30.9-9.2-59-24.9-82.7-45.4zm-68.7-231C63.2 115.4 127.9 54.3 208.8 37l.1 .4 76.6 214.5-33.2 33.2-211.7-90.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCroissant = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;